/**
 * api.ts — Single source of truth for the Shield backend base URL.
 *
 * Import this file early (index.tsx) so axios.defaults.baseURL is set
 * before any request is made. All relative "/api/..." paths will then
 * resolve to http://localhost:8000/api/...
 *
 * In production, set REACT_APP_API_BASE in the build environment.
 */

import axios from 'axios';

const API_BASE: string =
  process.env.REACT_APP_API_BASE ?? 'http://localhost:8000/api';

// Apply as axios default so every call uses the absolute URL automatically
axios.defaults.baseURL = API_BASE.replace(/\/api$/, ''); // e.g. http://localhost:8000

export default API_BASE;
